<template>
  <div style="width: 300px;">
    <b-row style="border-bottom: 1px solid #959595; margin-left: -10px; margin-right: -10px">
      <b-col>
        <p class="no-over-flow" style="font-size: 16px; font-weight: 400; margin-bottom: 0.5rem; padding-right: 8px"><strong><slot name="header"></slot></strong></p>
      </b-col>
    </b-row>
    <b-row style="margin-top: 12px">
      <b-col>
        <p class="no-over-flow" style="font-size: 14px; font-weight: 400; margin-bottom: 0.5rem"><strong><slot name="subject"/></strong></p>
        <p style="font-size: 14px; font-weight: 400; margin-bottom: 0.5rem"><slot name="memo"/></p>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "TaskMapPopup",
}
</script>

<style scoped>
.no-over-flow {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow-x: hidden;
}
</style>
